import { Box, Container, Drawer } from '@material-ui/core';
import React, { ReactElement } from 'react';

import DrawerToolbar from 'common/components/drawer/drawer-toolbar';
import BroadCastAPI from 'components/broadcast/api/broadcast-api-v2';
import { MessageTemplate } from 'components/broadcast/models/message-template';
import Department from 'components/setting/models/department';
import AppSnackbar from 'components/snackbar/snackbar';

import TaskTypeForm from './task-type-form';
import { TaskType } from 'components/lead/models/task';

function EditTaskTypeDrawer({
  departments,
  open,
  taskType,
  onClose,
  onSave,
}: {
  departments: Department[];
  open: boolean;
  taskType: TaskType | null;
  onClose(): void;
  onSave(value: any): Promise<void>;
}): ReactElement {
  const [showSnackbar] = AppSnackbar.useSnackBar();

  let taskDepartments: Department[] = taskType ? taskType.departments.map(x => {
    let d: Department = {
      departmentId: x.departmentId,
      departmentName: x.departmentName,
      dealerLocationId: 0,
      dealerLocationName: "",
      departmentType: "",
      phoneNumber: "",
      userCount: 0,
      users: [],
      isTollFreeNumber: false,
    }
    return d;
  }) : [];

  // const [taskTypeState, setTaskTypeState] = React.useState<TaskType | null>(taskType);

  // React.useEffect(() => {
  //   async function fetchQuickMessage(): Promise<void> {
  //     try {
  //       const response = await BroadCastAPI.getMessageTemplate(taskTypeId);
  //       if (!response) throw new Error('Invalid response');
  //       setQuickMessage(response);
  //     } catch (error) {
  //       showSnackbar({ type: 'error', message: 'Unable to get quick message' });
  //       onClose();
  //       setQuickMessage(undefined);
  //     }
  //   }
  //   if (quickMessageId) {
  //     fetchQuickMessage();
  //   }
  // }, [quickMessageId, onClose, showSnackbar]);

  return (
    <Drawer PaperProps={{ style: { width: '40%' } }} variant="temporary" anchor="right" open={open} onClose={onClose}>
      <DrawerToolbar title="Edit Task Type" onClose={onClose} />
      <Box mb={1} />
      <Container>
        {open && (
          <TaskTypeForm
            departments={departments}
            taskTypeDepartments={taskDepartments}
            onCancel={onClose}
            onSubmit={(value, createMore): Promise<void> => onSave(value)}
            taskType={taskType}
          />
        )}
      </Container>
    </Drawer>
  );
}

export default EditTaskTypeDrawer;
